const fields = [
    ["msdyn_description", "Name"],
    ["msdyn_start", "Start"],
    ["msdyn_end", "End"],
    ["msdyn_duration", "Duration (minutes)"],
    ["msdyn_type", "Type"],
    ["msdyn_entryStatus", "Status"],
    ["regardingobjectid", "Regarding"],
    ["msdyn_projecttaskid", "Project task"],
    ["msdyn_bookableresourcebooking", "Booking"],
    ["msdyn_transactioncategoryid", "Service type"],
    ["resourceCategoryId", "Role"],
    ["crb7a_detailsofwork", "Details of Work"],
    ["msdyn_externaldescription", "External comments"],
];
function display(value) {
    if (value == null || value === "")
        return "(not set)";
    if (typeof value === "object")
        return value.display || value.id;
    return String(value);
}
export function staffAuditNotes(employee, before, after) {
    const changes = fields.filter(([key]) => JSON.stringify(before?.[key] ?? "") !== JSON.stringify(after[key] ?? ""))
        .map(([key, label]) => before
        ? `${label}:\n  Before: ${display(before[key])}\n  After: ${display(after[key])}`
        : `${label}: ${display(after[key])}`);
    return `Recorded on behalf of ${employee}.\nEmployee resource: ${after.bookableresource}\n\n${changes.join("\n\n") || "No field values changed."}`;
}
